import { FunctionComponent, ReactElement } from 'react';
import { IconButton, Tooltip } from '@mui/material';
import RefreshIcon from '@mui/icons-material/Refresh';

interface RefreshButtonProps {
	onClick: () => unknown;
	disabled?: boolean;
}

const RefreshButton: FunctionComponent<RefreshButtonProps> = ({
	onClick,
	disabled,
}): ReactElement => (
	<Tooltip title="Refresh">
		<span>
			<IconButton aria-label="Refresh" onClick={() => onClick()} disabled={disabled}>
				<RefreshIcon />
			</IconButton>
		</span>
	</Tooltip>
);

export default RefreshButton;
